import React from "react";
import { TextField } from "..";
import styles from "./search-field.module.scss";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import { isAlphaNumeric } from "utils/text.utils";
import { useHistory } from "react-router-dom";

const SearchField = ({ name, onClear, onChange, restrict = true, ...props }) => {
  const history = useHistory();
  const { location } = history || {};
  const { state } = location || {};
  const { searchKey = "" } = state || {};

  return (
    <TextField
      onChange={(name, { value }) => {
        if (restrict && !isAlphaNumeric(value)) {
          return;
        }

        onChange(name, { value });
      }}
      {...props}
      prefix={<SearchIcon className={styles.searchIcon} />}
      suffix={
        props.value ? (
          <CloseIcon
            className={styles.clearIcon}
            onClick={() => {
              onChange(name, { value: "" });
              if (searchKey) {
                history.push(location.pathname, {
                  ...state,
                  searchKey: "",
                });
              }
              props.onEnter();
            }}
          />
        ) : null
      }
    />
  );
};

export default SearchField;
